import React from 'react';
export function Footer() {
  return <footer className="bg-black text-gray-400 py-12 px-4 text-center" data-id="element-137">
      <div className="max-w-4xl mx-auto" data-id="element-138">
        <h3 className="text-2xl font-black text-white mb-4" data-id="element-139">
          🧪 QUÍMICA EN ACCIÓN
        </h3>
        <p className="mb-2" data-id="element-140">
          El sistema de planificación de Química N°1 para docentes de secundaria
          en Argentina.
        </p>
        <p className="mb-8 italic" data-id="element-141">
          Porque enseñar Química no debería costarte todos los domingos del año.
        </p>

        <div className="border-t border-gray-800 pt-8 text-sm" data-id="element-142">
          <p className="mb-4" data-id="element-143">
            © 2025 QUÍMICA EN ACCIÓN™ — Todos los derechos reservados
          </p>
          <div className="flex justify-center gap-4" data-id="element-144">
            <a href="#" className="hover:text-white transition-colors" data-id="element-145">
              Privacidad
            </a>
            <span data-id="element-146">·</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-147">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}